import React from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge } from "@/components/common";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const { data, isLoading } = useQuery({ queryKey: ["audit"], queryFn: () => get("/admin/audit-logs") });
  if (isLoading) return <PageLoader />;
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Immutable trail of important admin & teacher actions" />
      {!data?.length ? <EmptyState icon={ScrollText} title="No audit entries" /> : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="text-left p-3">User</th><th className="text-left p-3">Role</th><th className="text-left p-3">Action</th><th className="text-left p-3">Entity</th><th className="text-left p-3">Time</th></tr></thead>
            <tbody>{data.map((a) => (
              <tr key={a.id} className="border-t border-slate-100">
                <td className="p-3 font-medium text-slate-800">{a.user_name}</td>
                <td className="p-3"><Badge tone="slate">{a.role}</Badge></td>
                <td className="p-3 font-mono text-xs text-indigo-700">{a.action}</td>
                <td className="p-3 text-slate-600">{a.entity} <span className="text-xs text-slate-400">{a.metadata?.title || a.metadata?.name || ""}</span></td>
                <td className="p-3 text-slate-500">{new Date(a.created_at).toLocaleString()}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
